import { render } from "./BaseTableWrapper.vue?vue&type=template&id=52076666"
const script = {}

import exportComponent from "/mnt/c/Users/henno/Documents/GitHub/radisol/toothy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__